// extracted by mini-css-extract-plugin
export var markdown = "_v7-0";
export var tableWrapper = "_v7-1";